var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('form-base',{attrs:{"paramId":_vm.$route.params.id},on:{"onSubmitInstituicao":_vm.onSubmitInstituicao}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }